import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const ItemList = styled.div `
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    gap: 30px;
  }
`;
const Item = styled.div `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 4;
  }
`;
export default {
    Item,
    ItemList,
};
